import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplyColumnStateParams, FilterModel } from 'ag-grid-enterprise';
import { DateTime } from 'luxon';
import { from } from 'rxjs';
import { Note } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { NoteDisplayModalComponent } from 'src/app/modals/note-display-modal/note-display-modal.component';
import { CompanyService } from 'src/app/services/company.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';

@Component({
  selector: 'app-admin-client-notes',
  templateUrl: './admin-client-notes.component.html',
  styleUrls: ['./admin-client-notes.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientNotesComponent {
  constructor(
    private CompanyService: CompanyService,
    private SharedDataService: SharedDataService,
    private ModalService: NgbModal,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {
    this.SharedDataService.listenForEvent<number>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && typeof data === 'number') {
          this.CompanyId = data;

          Object.assign(this.SuppliedGridQueryData, {
            CompanyId: this.CompanyId,
            isSensitive: [true, false]
          });

          from(
            companiesService.findOneById({
              pathParams: { companyId: this.CompanyId }
            })
          ).subscribe({
            next: (Company) => {
              const { legalName } = Company;

              this.SharedDataService.sendEvent(
                'SetTitle',
                `Notes - ${legalName}`
              );
              this.ChangeDetectorRef.markForCheck();
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');
  }

  SuppliedGridQueryData: GenericObject = {};
  CompanyId?: number;

  // Display these actions in the action column.
  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  FilterModel: FilterModel = {
    createdAt: {
      filterType: 'date',
      type: 'greaterThan',
      dateFrom: DateTime.fromJSDate(new Date())
        .minus({ months: 1 })
        .toFormat('yyyy-MM-dd HH:mm:ss'),
      dateTo: null
    }
  };

  SortState: ApplyColumnStateParams = {
    state: [{ colId: 'createdAt', sort: 'desc' }]
  };

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: Note;
  }) {
    if (action === 'view') {
      const { id: NoteId } = rowData;

      // Open note modal.
      const { componentInstance } = this.ModalService.open(
        NoteDisplayModalComponent,
        { backdrop: 'static', size: 'lg' }
      );
      Object.assign(componentInstance, { NoteId });
    }
  }
}
